module.exports = __webpack_public_path__ + "static/media/ios-eye.540ca603.svg";